import { render } from "./OrganizationList.vue?vue&type=template&id=2104040e&scoped=true"
import script from "./OrganizationList.vue?vue&type=script&lang=js"
export * from "./OrganizationList.vue?vue&type=script&lang=js"

import "./OrganizationList.vue?vue&type=style&index=0&id=2104040e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2104040e"]])

export default __exports__